'use client';

import { useState, useEffect } from 'react';


interface SocialLoginProps {
  onSocialLogin: (provider: 'google' | 'facebook') => void;
  isLoading: boolean;
}

const SocialLogin = ({ onSocialLogin, isLoading }: SocialLoginProps) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="w-full max-w-md mx-auto mt-6">
        <div className="animate-pulse space-y-3">
          <div className="h-12 bg-muted rounded"></div>
          <div className="h-12 bg-muted rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-md mx-auto mt-6">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border"></div>
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-background text-muted-foreground">Or continue with</span>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-3">
        <button
          onClick={() => onSocialLogin('google')}
          disabled={isLoading}
          className="flex items-center justify-center gap-2 px-4 py-3 bg-card border border-border rounded-md font-medium text-sm transition-smooth hover:bg-muted hover:shadow-elevation-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.8 10.2273C19.8 9.51818 19.7364 8.83636 19.6182 8.18182H10V12.05H15.4818C15.2364 13.3 14.5273 14.3591 13.4727 15.0682V17.5773H16.7636C18.7182 15.8364 19.8 13.2727 19.8 10.2273Z" fill="#4285F4"/>
            <path d="M10 20C12.7 20 14.9636 19.1045 16.7636 17.5773L13.4727 15.0682C12.5727 15.6682 11.4182 16.0227 10 16.0227C7.39545 16.0227 5.19091 14.2636 4.40455 11.9H0.995455V14.4909C2.78636 18.0591 6.10909 20 10 20Z" fill="#34A853"/>
            <path d="M4.40455 11.9C4.19091 11.3 4.06818 10.6591 4.06818 10C4.06818 9.34091 4.19091 8.7 4.40455 8.1V5.50909H0.995455C0.363636 6.77273 0 8.18182 0 10C0 11.8182 0.363636 13.2273 0.995455 14.4909L4.40455 11.9Z" fill="#FBBC04"/>
            <path d="M10 3.97727C11.5545 3.97727 12.9409 4.48182 14.0273 5.47273L17.0227 2.47727C14.9591 0.636364 12.6955 0 10 0C6.10909 0 2.78636 1.94091 0.995455 5.50909L4.40455 8.1C5.19091 5.73636 7.39545 3.97727 10 3.97727Z" fill="#EA4335"/>
          </svg>
          <span>Google</span>
        </button>

        <button
          onClick={() => onSocialLogin('facebook')}
          disabled={isLoading}
          className="flex items-center justify-center gap-2 px-4 py-3 bg-card border border-border rounded-md font-medium text-sm transition-smooth hover:bg-muted hover:shadow-elevation-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 14.9912 3.65684 19.1283 8.4375 19.8785V12.8906H5.89844V10H8.4375V7.79688C8.4375 5.29063 9.93047 3.90625 12.2146 3.90625C13.3084 3.90625 14.4531 4.10156 14.4531 4.10156V6.5625H13.1922C11.95 6.5625 11.5625 7.3334 11.5625 8.125V10H14.3359L13.8926 12.8906H11.5625V19.8785C16.3432 19.1283 20 14.9912 20 10Z" fill="#1877F2"/>
          </svg>
          <span>Facebook</span>
        </button>
      </div>
    </div>
  );
};

export default SocialLogin;